import { ApiResponse } from "@api/apiRequest";
import { tpApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

export const ACCOUNT_DELETE_STATUS = {
  SUCCESS: 0,
  FAILURE: 1,
  FAILURE_COACH_MATCH: 2,
} as const;

export type AccountDeleteStatus = typeof ACCOUNT_DELETE_STATUS[keyof typeof ACCOUNT_DELETE_STATUS];

const deleteAccount = async (): Promise<ApiResponse<{ value: AccountDeleteStatus }>> => {
  try {
    const response = await tpApi.post<{ value: AccountDeleteStatus }>(
      "/billing/v1/account/delete",
      undefined,
      { requireAuth: true }
    );
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/billing/v1/account/delete", method: "POST" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error deleting account" };
  }
};

export default deleteAccount;
